import integrationRoutes from '../helpers/routes';
import { IInstallation, IntegrationType, IOrganisation, IUser } from '../models';
import { RootState } from '../redux/rootReducer';
import { connectionTypes, installationStates, integrationTypes } from '../static/constants';

const tenantId = '7a8e7b5f-6b15-4db0-92d5-f774d230b276';
const tenantName = 'Gee Bagels';

export const headerDataMock = {
    header: {},
    headerAssets: {
        js: {},
        css: {},
    },
};

export const customConnectionsInstallationMock: IInstallation = {
    allowSmartLists: true,
    installationId: 'some-random-guid',
    integrationType: integrationTypes.CUSTOM as IntegrationType,
    state: installationStates.HEALTHY,
    connectionType: connectionTypes.OAUTH2,
    displayName: 'Custom connection',
    authorizeUrl: '',
    signUpUrl: '',
    routes: integrationRoutes.get(integrationTypes.CUSTOM),
    isOnboarded: false,
    requiresHostname: false,
    billing: {
        hasFreePlan: false,
        hasPaidPlan: true,
        hasBought: false,
        url: 'https://apps.livestage.test.xero.com/123456/nz/subscription/customconnection/add',
        manageSubscriptionUrl: 'https://apps.livestage.test.xero.com/123456/my-apps/78910',
        nextBillingDate: null,
        subscriptionEndDate: null,
    },
    versionSupport: {
        canUpdate: false,
        currentVersion: 1,
        latestVersion: 1,
        updateRequiresAuthorization: false,
    },
};

export const userMock: IUser = {
    given_name: 'Wally',
    family_name: 'West',
    email: 'wally.west@xero.com',
    sub: '',
    sid: '',
    auth_time: 1232,
    idp: '',
    preferred_username: 'Flash',
    xero_userid: '81b37c85-3ce0-4687-9cff-4945a965c166',
    amr: [],
};

export const userOrganisationsMock: IOrganisation[] = [
    {
        name: 'Gee Bagels',
        legalName: 'Gee Bagels',
        id: '35cf8364-75f4-499b-b12a-1ca83db1274e',
        userIsAdmin: true,
        hasInstallation: false,
        baseCurrency: 'NZD',
        class: 'PREMIUM',
        paysTax: true,
    },
];
export const organisationsMock = [
    {
        name: tenantName,
        legalName: tenantName,
        id: tenantId,
        userIsAdmin: true,
        baseCurrency: 'Nzd',
        paysTax: false,
        hasInstallation: false,
    },
    {
        name: 'Vandalay Industries',
        legalName: 'Georges lie',
        id: '691a7deb-c35b-4b0e-b207-7d120efc2756',
        userIsAdmin: true,
        baseCurrency: 'Aud',
        paysTax: false,
        hasInstallation: false,
    },
    {
        name: 'Tax registered org',
        legalName: 'Tax registered org',
        id: '691a7deb-c35b-4b0e-b207-7d120efc2757',
        userIsAdmin: true,
        baseCurrency: 'Nzd',
        paysTax: true,
        hasInstallation: false,
    },
    {
        name: 'Non-admin org',
        legalName: 'Non-admin org',
        id: '691a7deb-c35b-4b0e-b207-7d120efc2758',
        userIsAdmin: false,
        baseCurrency: 'Nzd',
        paysTax: false,
        hasInstallation: false,
    },
    {
        name: 'NZ non-tax org',
        legalName: 'NZ non-tax org',
        id: '691a7deb-c35b-4b0e-b207-7d120efc2759',
        userIsAdmin: true,
        baseCurrency: 'Nzd',
        paysTax: false,
        hasInstallation: false,
    },
    {
        name: 'NZ connected org',
        legalName: 'NZ connected org',
        id: '691a7deb-c35b-4b0e-b207-7d120efc2760',
        userIsAdmin: true,
        baseCurrency: 'Nzd',
        paysTax: false,
        hasInstallation: true,
    },
    {
        name: 'Tax registered org 2',
        legalName: 'Tax registered org 2',
        id: '691a7deb-c35b-4b0e-b207-7d120efc2789',
        userIsAdmin: true,
        baseCurrency: 'Nzd',
        paysTax: true,
        hasInstallation: false,
    },
];

export const storeDataMock: RootState = {
    bootstrap: {
        hasRequiredPlan: true,
        isAdmin: true,
        isAllowed: true,
        isBootstrapping: false,
    },
    installation: {
        installation: customConnectionsInstallationMock,
        isSyncing: false,
        isFetching: false,
    },
    organisation: {
        organisation: userOrganisationsMock[0],
        organisations: userOrganisationsMock,
    },
    user: {
        user: userMock,
    },
    connection: {},
};
